export const isChameleonActive = () => window?.chmln;